import React, { useEffect, useRef } from 'react';

import { useGoogleOAuth } from './hooks/useGoogleOAuth';
import { extractClientId } from './utils';

//const containerHeightMap = { large: 40, medium: 32, small: 20 };

export default function GoogleLogin({
    onSuccess,
    onError,
    useOneTap,
    promptMomentNotification,
    type = 'standard',
    theme = 'outline',
    size = 'large',
    text,
    shape,
    logo_alignment,
    width,
    locale,
    containerProps,
    parentBtnRef,
    ...props
}) {
    const btnContainerRef = useRef(null);
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();

    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;

    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    const promptMomentNotificationRef = useRef(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;

    useEffect(() => {
        if (!scriptLoadedSuccessfully) return;

        window?.google?.accounts?.id?.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                if (!credentialResponse?.credential) {
                    return onErrorRef.current?.();
                }

                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            ...props,
        });
        let btnRef = btnContainerRef;
        if (parentBtnRef) {
            btnRef = parentBtnRef;
        }
        window?.google?.accounts?.id?.renderButton(btnRef.current, {
            type,
            theme,
            size,
            text,
            shape,
            logo_alignment,
            width,
            locale,
        });
        //window?.google?.accounts?.id?.prompt((notification) => {
        //    console.log(notification);
        //    if(notification.isNotDisplayed() ){
        //        console.log(notification.getNotDisplayedReason())
        //        document.cookie =  `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
        //        window?.google?.accounts?.id?.prompt();
        //    }
        //    if(notification.isSkippedMoment()){
        //        console.log(notification.getSkippedReason())
        //        document.cookie =  `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
        //        window?.google?.accounts?.id?.prompt();
        //    }
        //});

        return () => {
            //if (useOneTap) window?.google?.accounts?.id?.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale,
    ]);

    return (
        <div
            {...containerProps}
            ref={btnContainerRef}
            //style={{ height: containerHeightMap[size], ...containerProps?.style }}
        />
    );
}
